export default "__VITE_ASSET__Bu6n0L6E__"